export default function ($scope, $stateParams, deleteUser, $state, toaster, userDetails) {
    const userId = $stateParams.userId;

    $scope.recordNotFetched = true;
    $scope.errorOccured = false;
    $scope.delete = delUser;
    $scope.cancel = cancelDelete;
    $scope.confirm = confirmDelete;

    userDetails(userId)
        .then(userData => {
            $scope.recordNotFetched = false;
            $scope.errorsOccurred = false;
            $scope.userData = userData;
        })
        .catch(() => {
            $scope.recordNotFetched = true;
            $scope.errorsOccurred = true;
        });

    function delUser() {
        deleteUser(userId)
            .then(() => {
                $state.go('users.list');
                toaster.pop('success', 'The user has been successfully deleted');
            })
            .catch(() => {
                toaster.pop('error', 'An error occured when deleting the user');
            });
        // $scope.confirmDelete = true;
    }

    function cancelDelete() {
        $scope.confirmDelete = false;
    }

    function confirmDelete() {
        deleteUser(userId)
            .then(() => {
                $state.go('users.list');
                toaster.pop('success', 'The user has been successfully deleted');
            })
            .catch(() => {
                toaster.pop('error', 'An error occured when deleting the user');
            });
    }
}



// WEBPACK FOOTER //
// ./Client/app/admin/users/controllers/delete/deleteUserCtrl.js